import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const deleteInitiative = createAsyncThunk(
  "initiatives/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      if (!response.data?.success) {
        return rejectWithValue(response.data?.message || "Failed to delete initiative");
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete initiative");
    }
  }
);
